import React, { useCallback, useContext } from 'react'
import { Button, Label } from 'components/Form'
import { Can } from 'components/Permissions'
import { features } from 'keys'
import { AudioTitleStyles } from '../Style'
import { Skeleton } from '@mui/material'
import { AudioEditorContext } from './AudioEditorContext'
import HeaderSettings from '../HeaderSettings'
import IconTabs from 'components/Tabs/IconTabs'
import { useSelector } from 'react-redux'


const AudioHeader = (props) => {
    const { id, title, actionBtns, showSettingsBtns, isAudioMarkingMode } = props

    const { assessment } = useSelector(state => state.assessment)
    const { state } = useContext(AudioEditorContext)
    const { isLoading, isNetoAudio, setIsNetoAudio, regionsList } = state

    const audioBtns = [{
        type: "neto",
        label: "אודיו נטו",
        icon: <i className="fa-regular fa-scissors" />,
        disabled: !assessment.neto_audio_file
    },
    {
        type: "source",
        label: "אודיו ברוטו",
        icon: <i className="fa-sharp fa-thin fa-file-music" />,
    }]

    const updateAudio = useCallback((index) => {
        if (index)
            setIsNetoAudio(false)
        else setIsNetoAudio(true)

    }, [isNetoAudio])

    return (
        <AudioTitleStyles>
            <div className='header-items'>
                {id ?
                    <>
                        {id &&
                            <Can I="read" a={features.transcription_system}>
                                <Label className="txt" bold label={`מבדק ${id}`} fontSize={16} />
                            </Can>
                        }
                        <div className="txt" >{title}</div>
                    </> :
                    <div className='flex'>
                        <Skeleton variant="rectangular" width="100%" height={20} animation="wave" style={{ width: 80, borderRadius: '4px', marginBottom: '10px' }} />
                        <Skeleton variant="rectangular" width="100%" height={20} animation="wave" style={{ width: 80, borderRadius: '4px', marginBottom: '10px' }} />
                    </div>
                }
            </div>
            {showSettingsBtns && <HeaderSettings {...props} />}
            <div className='header-items'>
                {isLoading || <>
                    {actionBtns?.map((btn) =>
                        <Button {...btn}
                            variant="solid2"
                            size="small"
                            color="light"
                            action={() => btn.action(regionsList)}
                        />
                    )}
                    <IconTabs
                        tabs={audioBtns}
                        value={isNetoAudio ? 0 : 1}
                        handleTab={updateAudio}
                    />
                </>}
            </div>
        </AudioTitleStyles>
    )
}

export default AudioHeader